import './ActivityResultStates.scss';

import * as React from 'react';

import { translate } from '~l10n/client';

import { UIButton } from '~shared/components/buttons';
import { Stack } from '~shared/components/Stack';

export const ActivityResultError = () => {
  return (
    <div className="activity-result-states-container flex flex-col justify-center items-center">
      <svg width="180" height="180" viewBox="0 0 180 180">
        <path
          className="fill-grey-100 "
          d="M94.892 11.175a10.812 10.812 0 014.742 4.747l70.193 138.363c2.702 5.327.579 11.838-4.743 14.543a10.797 10.797 0 01-4.892 1.172H19.806C13.838 170 9 165.157 9 159.183c0-1.702.401-3.38 1.171-4.898L80.364 15.922c2.702-5.327 9.206-7.452 14.528-4.747zM96 135H83a3 3 0 00-3 3v13a3 3 0 003 3h13a3 3 0 003-3v-13a3 3 0 00-3-3zm.956-73H82a2 2 0 00-1.955 2.044l1.1 50A2 2 0 0083.143 116h12.712a2 2 0 002-1.956l1.1-50V64a2 2 0 00-2-2z"
        />
      </svg>
      <div className="px-8 pt-12 max-w-3xl">
        <Stack space="8" align="center">
          <span className="font-display text-md font-500 text-blue-900">
            {translate('Something Went Wrong')}
          </span>
          <p className="font-sans text-base leading-8 text-blue-900 text-center">
            {translate('Please try again or contact support for assistance.')}
          </p>
          <UIButton
            onClick={() => {
              window.location.reload();
            }}
          >
            {translate('Reload')}
          </UIButton>
        </Stack>
      </div>
    </div>
  );
};
